// Pure helpers of the queue screens (no React, no network), so they can be tested alone.

export const QUEUE_STAGES = [
  { code: 'REGISTRATION', label: 'Registration' },
  { code: 'BILLING', label: 'Billing' },
  { code: 'COLLECTION', label: 'Sample collection' },
  { code: 'REPORT', label: 'Report desk' },
];

export const stageLabel = (code) => QUEUE_STAGES.find((s) => s.code === code)?.label || code || '';

/** The stage a patient normally goes to next; null after the last one. */
export const nextStageOf = (code) => {
  const i = QUEUE_STAGES.findIndex((s) => s.code === code);
  return i >= 0 && i < QUEUE_STAGES.length - 1 ? QUEUE_STAGES[i + 1].code : null;
};

export const STATUS_LABELS = {
  WAITING: 'Waiting', CALLED: 'Called', SERVING: 'Serving', DONE: 'Done', SKIPPED: 'Skipped',
};

/** What the desk may do with a token in this status (the server enforces the same table). */
export const ticketActions = (status) => ({
  start: status === 'CALLED',
  complete: status === 'CALLED' || status === 'SERVING',
  skip: status === 'CALLED',
  requeue: status === 'CALLED',
  recall: status === 'CALLED' || status === 'SKIPPED',
  transfer: status === 'CALLED' || status === 'SERVING',
});

export const formatWait = (minutes) => {
  const m = Math.max(0, Math.round(Number(minutes) || 0));
  if (m < 60) return `${m} min`;
  return `${Math.floor(m / 60)} h ${m % 60} min`;
};

/** "R-014" is read as "R 14" so a speech engine does not say "dash zero one four". */
export const spokenToken = (label) => {
  const m = /^([A-Z])-0*(\d+)$/.exec(String(label || '').trim());
  return m ? `${m[1]} ${m[2]}` : String(label || '');
};

export const announcementText = (label, counterName) => `Token ${spokenToken(label)}, please go to ${counterName}`;

/**
 * The counters whose token was called (or called again) between two board reads. The first read announces nothing.
 * A call is a new token label, or a higher call count for the same label.
 */
export const newCalls = (previous, current) => {
  if (!previous) return [];
  const before = new Map((previous || []).map((c) => [c.counterId, c]));
  return (current || []).filter((c) => {
    if (!c.tokenLabel || c.status !== 'CALLED') return false;
    const old = before.get(c.counterId);
    return !old || old.tokenLabel !== c.tokenLabel || (old.callCount || 0) < (c.callCount || 0) || old.status !== 'CALLED';
  });
};

/** Board counters grouped by stage in the usual order; empty stages are left out. */
export const groupByStage = (counters) => QUEUE_STAGES
  .map((s) => ({ ...s, counters: (counters || []).filter((c) => c.stage === s.code) }))
  .filter((g) => g.counters.length > 0);

export const issuePayload = ({ stage, priority, name, mobile }) => ({
  stage,
  priority: !!priority,
  pName: (name || '').trim() || undefined,
  mobile: (mobile || '').replace(/\D/g, '') || undefined,
});
